module.exports = __webpack_public_path__ + "static/media/darkback.46d37e45.jpg";